<template>
  <div class="avatar-wrapper">
    <v-avatar class="avatar" color="white" size="46">
      <img v-if="avatarSrc" :src="avatarSrc" />
      <v-icon
        v-else-if="isOwner"
        size="24"
        class="avatar__icon avatar__icon--primary"
        >icon-author</v-icon
      >
      <v-icon v-else size="24" class="avatar__icon avatar__icon--secondary"
        >icon-user-filled</v-icon
      >
    </v-avatar>
    <div v-if="isLocalGuide && !isOwner" class="badge">
      <v-icon size="14px">mdi-star</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "QaAvatar",
  props: {
    isOwner: {
      type: Boolean,
      default: false
    },
    isLocalGuide: {
      type: Boolean,
      default: false
    },
    avatarSrc: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-wrapper {
  position: relative;
}

.avatar {
  box-shadow: inset 0 0 1px rgba($gray-dark, 0.8);

  &__icon {
    &--secondary {
      color: $grey-darker;
    }

    &--primary {
      color: $primary;
    }
  }
}

.badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #db9c1f;
  display: flex;
  justify-content: center;

  .v-icon {
    color: white;
  }
}
</style>
